var BASWebServices;
(function (BASWebServices) {
    var RunButtonController = (function () {
        function RunButtonController($scope, $rootScope, $http, $timeout, wsData, ngDialog) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$http = $http;
            this.$timeout = $timeout;
            this.wsData = wsData;
            this.ngDialog = ngDialog;
            this.$scope.rbc = this;
            this.$scope.ajaxQueueDone = true;
        }
        RunButtonController.prototype.run = function () {
            this.$scope.RESULT = [];
            this.$scope.RESULT_CONTENT = "";
            this.$rootScope.$broadcast("messageBoxIgnoreOldMessages");
            var serviceName = this.wsData.getServiceName();
            if (!this.$scope.touRead) {
                this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Confirmation of your knowledge of the Terms of Usage and the way to cite us is missing.', "Please check the checkbox to confirm the following statement: I have read and accepted the terms of usage for this service, including the policy of monitoring access to the services (paragraph 5). I hereby confirm that I'm a member of an academic institution or that I have obtained a BAS user license for this service. In case of a publication of my results I will use a proper citation to this service.");
            }
            else if (!(this.wsData.doNecessaryKeysExist(serviceName))) {
                var missingKeys = this.wsData.getMissingNecessaryKeys(serviceName);
                var missingKeyString = "The following key(s) is/are missing: ";
                for (var i = 0; i < missingKeys.length; i++) {
                    missingKeyString += missingKeys[i] + " ";
                }
                missingKeyString += ".";
                this.$rootScope.$broadcast('messageForBox', 'ERROR', 'No/Not all necessary files uploaded - please make sure you clicked the upload button and green check marks are displayed next to the files/pairs.', missingKeyString);
            }
            else if (this.wsData.doInvalidDataExist()) {
                this.$rootScope.$broadcast('messageForBox', 'ERROR', 'The service cannot be run with these options. Please check all text options for disallowed spaces.', '');
            }
            else {
                var _rootScope = this.$rootScope;
                var _http = this.$http;
                var _timeout = this.$timeout;
                _rootScope.$broadcast("dimming_screen_on");
                _rootScope.dimmingPage = true;
                var keepSessionAliveVariable = "keepSessionAlivePromise";
                this.keepSessionAlive(keepSessionAliveVariable);
                this.ngDialog.open({
                    template: 'views/partials/dialogs/hints.html',
                    className: 'ngdialog-theme-default',
                    closeByEscape: true,
                    scope: _scope,
                });
                var queries = this.wsData.getXWWWURLEncodedStringFromOptions();
                console.log("Creating an AjaxQeue with " + BASWebServices.ConfigService.GET_NUMBER_THREADS() + " threads");
                var queue = new BASWebServices.AjaxQueue(BASWebServices.ConfigService.GET_NUMBER_THREADS(), this.$http, this.$rootScope.ngProgressBar, function () {
                    _rootScope.$broadcast('CLOSE_HINT_IF_STIL_OPENED');
                    _rootScope.$broadcast("AjaxQueueDoneRunButtonController");
                    _rootScope.$broadcast("dimming_screen_off");
                    _rootScope.keepSessionAlivePromise;
                    _rootScope.dimmingPage = false;
                    _rootScope.$broadcast("dimming_screen_off");
                    _timeout.cancel(_rootScope[keepSessionAliveVariable]);
                    console.log("Just killed the keep sessionalive promise");
                });
                this.$scope.ajaxQueueDone = false;
                var _scope = this.$scope;
                this.$rootScope.$on("AjaxQueueDoneRunButtonController", function (args) {
                    _scope.ajaxQueueDone = true;
                });
                var successCallback = function (data, status, headers, config) {
                    var wsrl = new BASWebServices.WebServiceResonseLink(data);
                    var pairName = RunButtonController.getPairNameFromWSData(config.callerObjectContext.wsData, config.numberOfQuery);
                    if (wsrl.success) {
                        config.callerObjectContext.handleSuccessfulRun(wsrl.downloadLink, config.numberOfQuery);
                        var warningMessage = '';
                        var serviceState = 'Success';
                        if (wsrl.output != "" && wsrl.warnings != "") {
                            warningMessage = "Output/Warnings: " + wsrl.output + "<br/>" + wsrl.warnings;
                            serviceState = 'Success (+Warning/+Information)';
                        }
                        else if (wsrl.output != "") {
                            warningMessage = "Output: " + wsrl.output;
                            serviceState = 'Success (+Information)';
                        }
                        else if (wsrl.warnings != "") {
                            warningMessage = "Warnings: " + wsrl.warnings;
                            serviceState = 'Success (+Warning)';
                        }
                        else {
                            warningMessage = '- no additional info -';
                        }
                        config.callerObjectContext.$rootScope.$broadcast('messageForBox', serviceState, 'Service execution was successful [' + pairName + ']', warningMessage);
                    }
                    else {
                        var errorMessage = '';
                        var outputExists = wsrl.output != '';
                        var warningExists = wsrl.warnings != '';
                        if (wsrl.output.lastIndexOf("\\n") != 0) {
                            console.log("AAAHHJJJAAA93939393999");
                        }
                        if (outputExists) {
                            errorMessage += wsrl.output;
                            if (warningExists)
                                errorMessage += "\n\n";
                        }
                        if (warningExists) {
                            if (wsrl.warnings.toLowerCase().lastIndexOf('error') == -1) {
                                errorMessage += "ERROR: ";
                            }
                            errorMessage += wsrl.warnings;
                        }
                        config.callerObjectContext.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful! [' + pairName + ']', errorMessage + " | Status: " + status);
                    }
                };
                var errorCallback = function (data, status, headers, config) {
                    console.error("Service execution was unsuccessful", status, data, config);
                    var pairName = RunButtonController.getPairNameFromWSData(config.callerObjectContext.wsData, config.numberOfQuery);
                    if (data === null && status === -1) {
                        var errorMessage = "Log in at the <a target=\"_blank\" href=\"https://clarin.phonetik.uni-muenchen.de/Shibboleth.sso/Login?target=https://clarin.phonetik.uni-muenchen.de/BASRepository\">BAS Repository</a> in another tab of your browser" +
                            "and then return to this tab and re-run the service.<br>" +
                            "You can immediately close the BAS Repository tab after successful login; this will make sure you are authenticated with the BAS Web Services as well. " +
                            "Alternatively, you can simply reload this page and you will be prompted to log in, but then you will have to re-upload the data you have already uploaded.";
                        var shortMessageContainsSafeHtml = false;
                        var longMessageContainsSafeHtml = true;
                        config.callerObjectContext.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful – the server has sent a generic error. If you have been using a service involving ASR, this could mean that you have been logged out of Shibboleth – then click on this message to log in again! [' + pairName + ']', errorMessage, shortMessageContainsSafeHtml, longMessageContainsSafeHtml);
                    }
                    else {
                        config.callerObjectContext.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful! [' + pairName + ']', "Errors: " + data + " | Status: " + status);
                    }
                };
                for (var index = 0; index < queries.length; index++) {
                    var queryCurrent = queries[index];
                    var method = 'POST';
                    queue.ajaxEnqueue(method, queryCurrent, index, this, successCallback, errorCallback);
                }
            }
        };
        RunButtonController.prototype.doNothing = function () {
            console.log("Still processing, clicking this button is only possible after the processing is finished");
        };
        RunButtonController.prototype.scrollToBottom = function () {
            this.$timeout(function () {
                var scrollElement = document.querySelector("upload-element-multiple");
                if (scrollElement) {
                    scrollElement.scroll({ top: scrollElement.scrollHeight, behavior: 'smooth' });
                }
            }, 0);
        };
        RunButtonController.prototype.handleSuccessfulRun = function (downloadLink, setNumber) {
            this.wsData.add(setNumber, "result", downloadLink);
            var _rootScope = this.$rootScope;
            this.$rootScope.$broadcast("prevent_window_from_being_closed_ACTIVATE");
            this.$timeout(function () {
                _rootScope.$broadcast("prevent_window_from_being_closed_ACTIVATE");
            }, 1000);
            if (this.$scope.RESULT === undefined) {
                this.$scope.RESULT = new Array();
            }
            this.$scope.RESULT[setNumber] = downloadLink;
            this.$scope.addressOfImageShownAfterSecondStep = "";
            this.scrollToBottom();
            if (this.$scope.preview == 'true') {
                this.$http.get(downloadLink, {
                    _this: this
                })
                    .then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var content = data;
                    config._this.$scope.RESULT_CONTENT = content;
                })
                    .catch(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    config._this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful!', "Data: " + data + " | Status: " + status);
                });
            }
        };
        RunButtonController.prototype.getZipFile = function () {
            this.$rootScope.dimmingPage = true;
            this.$rootScope.$broadcast("dimming_screen_on");
            var ngProgBar = this.$rootScope.ngProgressBar;
            ngProgBar.start();
            ngProgBar.set(30);
            var results = this.$scope.RESULT;
            var formData = new FormData();
            for (var i = 0; i < results.length; i++) {
                var result = results[i];
                formData.append('file' + i, result);
            }
            var allOptions = this.wsData.getData();
            var outFormat = allOptions["OUTFORMAT"];
            if (outFormat != null) {
                formData.append("OUTFORMAT", outFormat);
            }
            var emuRDBname = null;
            if (allOptions["emuRDBname"] !== undefined) {
                emuRDBname = allOptions["emuRDBname"];
            }
            else {
                var htmlElement = document.getElementById("emuRDBname");
                if (htmlElement != null)
                    emuRDBname = htmlElement["placeholder"];
            }
            formData.append("emuRDBname", emuRDBname);
            var sounds = null;
            if (allOptions["sounds"] !== undefined) {
                sounds = allOptions["sounds"];
            }
            else {
                var htmlElement = document.getElementById("sounds");
                if (htmlElement != null)
                    sounds = htmlElement["placeholder"];
            }
            formData.append("sounds", sounds);
            var outlierThreshold = null;
            if (allOptions["outlierThreshold"] !== undefined) {
                outlierThreshold = allOptions["outlierThreshold"];
            }
            else {
                var htmlElement = document.getElementById("outlierThreshold");
                if (htmlElement != null)
                    outlierThreshold = htmlElement["placeholder"];
            }
            formData.append("outlierThreshold", outlierThreshold);
            if (allOptions["gender"]) {
                formData.append("gender", allOptions["gender"]);
            }
            else {
                var htmlElement = document.getElementById("gender");
                if (htmlElement) {
                    formData.append("gender", htmlElement["value"]);
                }
            }
            if (allOptions["midpoint"]) {
                formData.append("midpoint", allOptions["midpoint"]);
            }
            else {
                var htmlElement = document.getElementById("midpoint");
                if (htmlElement) {
                    formData.append("midpoint", htmlElement["value"]);
                }
            }
            if (allOptions["outlierMetric"]) {
                formData.append("outlierMetric", allOptions["outlierMetric"]);
            }
            else {
                var htmlElement = document.getElementById("outlierMetric");
                if (htmlElement) {
                    formData.append("outlierMetric", htmlElement["value"]);
                }
            }
            if (allOptions["computeERatio"]) {
                formData.append("computeERatio", allOptions["computeERatio"]);
            }
            else {
                var htmlElement = document.getElementById("computeERatio");
                if (htmlElement) {
                    formData.append("computeERatio", htmlElement["value"]);
                }
            }
            this.$http.post(BASWebServices.ConfigService.GET_URL_ZIP_FILE_MULTIPLE(), formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
                progressBar: ngProgBar,
                _this: this
            })
                .then(function (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var config = response.config;
                var wsrlm = new BASWebServices.WebServiceResonseLink(data);
                var warningMessage = '';
                if (wsrlm.success) {
                    var serviceState = 'Success';
                    if (wsrlm.warnings != '') {
                        warningMessage = "Warnings: " + wsrlm.warnings;
                        serviceState = 'Success (+Warning)';
                    }
                    config._this.$rootScope.$broadcast('messageForBox', serviceState, 'Zip file successfully created!', warningMessage);
                    config._this.$rootScope.$broadcast('CLOSE_HINT_IF_STIL_OPENED');
                    config._this.$rootScope.dimmingPage = false;
                    config._this.$rootScope.$broadcast("dimming_screen_off");
                    config._this.$rootScope.ngProgressBar.complete();
                    config._this.$scope.addressOfImageShownAfterSecondStep = wsrlm.downloadLink.replace(/results-.*\.zip/, "VowelSpacePlotMedian.png");
                    config._this.scrollToBottom();
                    window.open(wsrlm.downloadLink, "_self");
                }
                else {
                    config._this.$rootScope.$broadcast('CLOSE_HINT_IF_STIL_OPENED');
                    config._this.$rootScope.dimmingPage = false;
                    config._this.$rootScope.$broadcast("dimming_screen_off");
                    config._this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Zip file could not be created!', wsrlm.output);
                    config._this.$rootScope.ngProgressBar.complete();
                }
            })
                .catch(function (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var config = response.config;
                config._this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful!', "Data: " + data + " | Status: " + status);
            });
        };
        RunButtonController.getPairNameFromWSData = function (wsData, numberOfQuery) {
            var wsDataObject = wsData.getData();
            var assoziativeArrayEntry = wsDataObject["sets"][numberOfQuery];
            var linkName = "";
            for (var key in assoziativeArrayEntry) {
                var txtNameTmp = assoziativeArrayEntry[key];
                if (txtNameTmp.lastIndexOf(BASWebServices.UploadElementMultiController.get_TEMPLATE_HACK_FILE_NAME_START()) != -1) {
                }
                else {
                    linkName = assoziativeArrayEntry[key];
                }
            }
            if (linkName === undefined)
                return '';
            else {
                var pairName = linkName.substring(linkName.lastIndexOf("/") + 1, linkName.lastIndexOf("."));
                return pairName;
            }
        };
        RunButtonController.prototype.keepSessionAlive = function (sessionAliveVariable) {
            var _this = this;
            var _rootScope = this.$rootScope;
            var _http = this.$http;
            var _timeout = this.$timeout;
            var rnd = Math.floor(Math.random() * 1000);
            var keepAliveURL = BASWebServices.ConfigService.GET_KEEP_ALIVE_URL() + "?" + rnd;
            _rootScope[sessionAliveVariable] = _timeout(function () {
                console.log("Execute keep alive get url");
                _http.get(keepAliveURL);
                console.log("Setting next keep alive get url in " + BASWebServices.ConfigService.GET_KEEP_ALIVE_INTERVAL() / 1000 + " seconds");
                _this.keepSessionAlive(sessionAliveVariable);
            }, BASWebServices.ConfigService.GET_KEEP_ALIVE_INTERVAL());
        };
        return RunButtonController;
    }());
    BASWebServices.RunButtonController = RunButtonController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=RunButtonController.js.map